__turbopack_context__.v({
  "button": "styles-module__cBE9Zq__button",
  "container": "styles-module__cBE9Zq__container",
  "icon": "styles-module__cBE9Zq__icon",
});
